module.exports = __webpack_public_path__ + "assets/fangqi.030fe8e7cc15ac1edee52b34b419a993.png";